module.exports = __webpack_public_path__ + "static/media/808-tom-10.62b242e1.wav";